import { useQueryClient } from 'react-query'

import { LinkCardRequest, LinkCardResponse } from '@cash-web/protos/squareup/franklin/app/card.pb'
import { GetProfileResponse } from '@cash-web/protos/squareup/franklin/app/profile.pb'
import { useQueryGetProfile } from '@cash-web/shared-data-access-api/react-query/useQueryGetProfile'
import { createReactQueryMutationHook } from '@cash-web/shared-data-access-api/types'
import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'

import { basePath } from '.'
import { updateInstruments } from './instrumentsUtil'

export const LinkCard = (data: LinkCardRequest, config?: CashRequestOptions): Promise<LinkCardResponse> =>
  post<LinkCardRequest, LinkCardResponse>(`${basePath}/link-card`, data, config)

const useMutationLinkCard = createReactQueryMutationHook('linkCard', LinkCard)

export const useOptimisticMutationLinkCard = (params: Parameters<typeof useMutationLinkCard>[0]) => {
  const queryClient = useQueryClient()

  return useMutationLinkCard({
    ...params,
    mutationOptions: {
      onSuccess: response => {
        const instrument = response.instrument
        const token = instrument?.token

        if (token === undefined || instrument === undefined) {
          return
        }

        queryClient.setQueryData<GetProfileResponse | undefined>(useQueryGetProfile.rootQueryKey, response => {
          if (response === undefined) {
            return undefined
          }

          const res = {
            ...response,
            profile: {
              ...response.profile,
              instruments: updateInstruments({
                instruments: response.profile?.instruments ?? [],
                newInstrument: { ...instrument, token },
              }),
            },
          }

          return res
        })
      },
    },
  })
}
